export default {
  title: {
    en: 'Other popular products with {note} note',
  },
  empty: {
    en: 'Nothing to show',
  },
}
